import { render, staticRenderFns } from "./people_det.vue?vue&type=template&id=1c96b3c8&lang=pug&"
import script from "./people_det.vue?vue&type=script&lang=js&"
export * from "./people_det.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports